/* eslint-disable */
import {useTranslation} from "react-i18next";
import React from "react";
import {CouponContext, StripePrice} from "../SubscriptionDetail";

const SinglePriceCard = ({ price, onSelect, selectedId, planButtonPressed }: { price: StripePrice,
    onSelect: (id: string) => void,
    planButtonPressed: () => void,
    selectedId: string }) => {
    const { t } = useTranslation();
    const coupon = React.useContext(CouponContext);

    const interval = price.recurring?.interval || 'month';
    const intervalCount = price.recurring?.interval_count || 1;
    const priceNumber = price.currency === 'usd' || price.currency ==='eur'
        ? price.unit_amount / 100 : price.unit_amount;
    let discountedPrice = priceNumber;
    if (coupon && coupon.percent_off) {
        discountedPrice = priceNumber * (1 - coupon.percent_off / 100);
    }
    const pricePerInterval = discountedPrice.toLocaleString('en-US', { style: 'currency', currency: price.currency.toUpperCase() });

    // Get localized interval name
    const getLocalizedInterval = (interval: string, count: number) => {
        const key = count > 1 ? `subscription.intervals.${interval}s` : `subscription.intervals.${interval}`;
        return t(key);
    };

    const localizedInterval = getLocalizedInterval(interval, intervalCount);
    const intervalText = `${intervalCount > 1 ? intervalCount + ' ' : ''}${localizedInterval}`;

    return (
        <div className="single-price-card" onClick={() => onSelect(price.id)}>
            <div className="single-price-card-content">
                <div className="single-price-left">
                    <div className="single-price-total">{t('subscription.total')}</div>
                    <div className="single-price-access">{t('subscription.fullAccess')}</div>
                </div>
                <div className="single-price-right">
                    <div className="single-price-amount">{pricePerInterval}</div>
                    <div className="single-price-period">$29.99</div>
                </div>
            </div>
            <button className="single-price-button" onClick={planButtonPressed}>
                {t('subscription.getMyPlanPayCard').toUpperCase()}
            </button>
        </div>
    );
};

export default SinglePriceCard;
